import React, { Component } from 'react';
import { BrowserRouter, Routes, Route, useLocation, useParams } from "react-router-dom";
import PropTypes from 'prop-types';
import { Helmet } from "react-helmet";
import $, { param } from 'jquery';
import ReactGA from 'react-ga';
import Cookies from 'universal-cookie';
import { Contest } from './Contest';
import { Questions } from './Questions'
import 'jquery-validation'

export class Register extends Component {

  

    static propTypes = {
        pageType: PropTypes.string,
        onChange: PropTypes.func,
        sponserId: PropTypes.number,
        recaptchaToken: PropTypes.string
    };


    constructor(props) {
        super(props);


        this.state = {
            data: {},
            loading: false,
            fname: '',
            lname: '',
            email: '',
            phone: '',
            city: '',
            country: '',
            age: '',
            gender: '',
            terms_ckbk: '',
            IsFormSubmitted: false,
            questions: {},
            index: 0,
            answer: '',
            userId: 0,
            contest: {},
            iscontestGoingOn: true,
            iscontestNotStarted: false,
            contestStartDate: {},
            items: [],
            isSubmited: false,
            qusAnswered: 0,
            showVideo: false,
            player: null,
            ageList: [],
            ansError: '',
            isScriptLoaded: false,
            contestId: ''
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleNextClick = this.handleNextClick.bind(this);
        this.handleContestClick = this.handleContestClick.bind(this);
        this.populateContest = this.populateContest.bind(this);
        this.handleContestSubmitClick = this.handleContestSubmitClick.bind(this);
        this.handleSwitchLiveClick = this.handleSwitchLiveClick.bind(this);
        this.resetErrorMsg = this.resetErrorMsg.bind(this);
        for (var i = 18; i < 80; i++) {

            this.state.ageList.push(i);
        }
       
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value,
            ansError: ''
        });
    }

    resetErrorMsg() {

        this.setState({ ansError: '' });
    }


    componentWillMount() {
        this.setState({ data: null, questions: null, contest: null, sponserId: this.props.sponserId });
        console.log("Reloading..");
    }

    componentDidMount() {        
        
        if (!this.state.isScriptLoaded) {

           

            //custom validation rule
            $.validator.addMethod("customemail",
                function (value, element) {
                    return /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(value);
                },
                "Sorry, I've enabled very strict email validation"
            );

            $.validator.addMethod("lettersonly", function (value, element) {
                return this.optional(element) || /^[a-z]+$/i.test(value);
            }, "Letters only please");

            $("#register_form").validate({
                rules: {
                    fname: {
                        required: true,
                        
                    },
                    lname: {
                        required: true,
                      
                    },
                    email: {
                        required: true,
                        customemail: true,
                    },
                    phone: {
                        required: true,
                        maxlength: 10,
                        minlength: 10,
                        number: true
                    },
                    city: {
                        required: true,
                       
                    },
                    country: {
                        required: true,
                        maxlength: 6,
                        minlength: 6,
                        number: true
                    },
                    age: {
                        required: true,
                    },
                    gender: {
                        required: true,
                    },
                    terms_ckbk: "required"
                },
                messages: {
                    fname: {
                        required: "Please enter your firstname",
                     

                    },
                    lname: {
                        required: "Please enter your lastname",
                     

                    },
                    email: {
                        required: "Please enter your email",
                        customemail: "Please enter a valid email Id",

                    },
                    phone: "Please enter a valid phone number",
                    city: "Please enter your city",
                    country: "Please enter your Pincode",
                    age: "Please enter your age",
                    gender: "Please enter your gender",
                    terms_ckbk: "Please accept our terms & conditions",

                },
                submitHandler: function (form) {
                    // some other code
                    // maybe disabling submit button
                    // then:
                    var form = $('#register_form').get(0);
                    $.removeData(form, 'validator');
                    $(form).submit();
                }
            });
            this.setState({ isScriptLoaded: true });
            console.log("Script Loaded Once");
            this.CheckUserIdExists();
            
        } else {
                
        }

    }


   async CheckUserIdExists() {
        const query = new URLSearchParams(window.location.search);
        if (query.size > 0) {
            let userid = query.get("id");

            const response = await fetch('v1/api/validateuser?uid=' + userid, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' }
            });
            const data = await response.json();


            if (data.status) {
                const cookies = new Cookies();
                let d = new Date();
                //d.setTime(d.getTime() + (minutes * 60 * 1000));
                cookies.set("userCookie", JSON.stringify(data.data), { path: "/" });
                //this.props.onChange(data.data.id);



                this.setState({
                    data: data,
                    loading: false,
                    fname: '',
                    lname: '',
                    email: '',
                    phone: '',
                    city: '',
                    country: '',
                    age: '',
                    gender: '',
                    terms: '',
                    userId: data.data.id
                }, async function () {
                    await this.populateQuestions(this.props.sponserId, data.data.id);


                });
            }
        }
    }

    async handleNextClick(event, questionItem, index) {

        console.log("Question Item " + questionItem.id + " Answer : " + this.state.answer);

        if (this.state.answer == "") {

            this.setState({ ansError : 'Please select your answer !' } );


        } else {

            this.state.ansError = '';
            var formData = {
                "QuestionId": questionItem.id,
                "OptionId": parseInt(this.state.answer),
                "UserId": this.state.userId
            };
            this.state.loading = true;


            $.ajax({
                url: 'v1/api/submitanswers',
                data: JSON.stringify(formData),
                dataType: 'json',
                contentType: "application/json; charset=utf-8",
                type: 'POST',

                success: (data) => {

                    if (data.status) {
                        this.setState({ qusAnswered: ++this.state.qusAnswered });
                        ReactGA.event({
                            category: 'Register',
                            action: 'Created New Profile'
                        });

                        let i = this.state.index <= this.state.questions.data.length ? this.state.index += 1 : 0;
                        this.setState({ index: i, answer: '' });
                        $("input:radio").prop('checked', false);


                        if (this.state.questions?.data?.length == this.state.qusAnswered) {
                            setTimeout(this.populateContest, 100);
                        }
                    }
                },

                error: (xhr, status, err) => {
                    console.error(status, err.toString()); // eslint-disable-line
                },
            });


        }

    };

    async handleSubmit(event) {

        var form = $('#register_form').get(0);
        $.removeData(form, 'validator');

        var formData = {

            "Firstname": this.state.fname,
            "Lastname": this.state.lname,
            "Email": this.state.email,
            "Mobilenumber": this.state.phone,
            "City": this.state.city,
            "Country": this.state.country,
            "Age": this.state.age,
            "Gender": this.state.gender,
            "token": this.props.recaptchaToken
        };
        this.state.loading = true;
        $.ajax({
            url: 'v1/api/register',
            data: JSON.stringify(formData),
            dataType: 'json',
            contentType: "application/json; charset=utf-8",
            type: 'POST',

            success: (data) => {

                if (data.status) {

                    const cookies = new Cookies();
                    let d = new Date();
                    //d.setTime(d.getTime() + (minutes * 60 * 1000));
                    cookies.set("userCookie", JSON.stringify(data.data), { path: "/" });
                    //this.props.onChange(data.data.id);



                    this.setState({
                        data: data,
                        loading: false,
                        fname: '',
                        lname: '',
                        email: '',
                        phone: '',
                        city: '',
                        country: '',
                        age: '',
                        gender: '',
                        terms: '',
                        userId: data.data.id

                    }, async function () {
                        await this.populateQuestions(this.props.sponserId, data.data.id);
                        
                        
                    });

                    ReactGA.event({
                        category: 'Register',
                        action: 'Created New Profile'
                    });


                } else {

                }
            },

            error: (xhr, status, err) => {
                console.error(status, err.toString()); // eslint-disable-line
            },
        });


        event.preventDefault();
    }



    registerClickHandle() {
        this.props.onChange(true);
    }


    async populateQuestions(sponserId, userId) {

        if (sponserId != null && userId != null) {

            const response = await fetch('v1/api/Questions?sponserId=' + sponserId + '&userId=' + userId, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' }
            });
            const data = await response.json();


            if (data != null && data.status) {
                this.setState({ questions: data, loading: false });
                console.log(data);
                this.setState({ index: 1 });
                if (data?.data?.length == 0) {
                    this.populateContest();
                }
            }
        }

    }

    renderQuestions(questionList) {

        if ((Object.keys(questionList).length === 0)) return (<></>);

        return questionList?.slice(this.state.index - 1, this.state.index).map((questionItem, idx) => {

            return (
                <>
                    <span>
                        <h5 id="question">{questionItem.title}</h5>
                        {this.renderOptionItem(questionItem.options)}
                        <li><lable class="error" id="ans_error">{this.state.ansError}</lable></li>
                        <button onClick={(event) => this.handleNextClick(event, questionItem, idx)} >{(this.state.questions.data.length == (this.state.index)) ? "Finish" : "Next"}</button>
                    </span>
                </>

            );
        });

    }

    renderOptionItem(optionList) {
        return optionList?.map((optionItem, idx) => { // here

            return (
                <>
                    <li>
                        <input type="radio" id={"option-" + optionItem.id} name="answer" value={optionItem.id} onChange={this.handleInputChange} />
                        <label for={"option-" + optionItem.id} onCLick={this.resetErrorMsg} >{optionItem.option}</label>
                    </li>
                </>
            );
        });
    }


    async populateContest() {

        const query = new URLSearchParams(window.location.search);
        var contestId = null;
        if (query.size > 0) {
            contestId = query.get("cid");
        }
        var url = "v1/api/GetContest/" + this.state.userId;
        if (contestId != null) {
            url = "v1/api/getcontestbycontestid/" + this.state.userId + "/" + contestId;
        }
        const response = await fetch(url, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        });
        const data = await response.json();
        if (data.status)
            this.setState({ items: data.data.items, loading: false, contest: data.data.contest, iscontestGoingOn: true, contestId: data.data.contestId });
        else if (data.statusMessage == "No active contest going on") {
            this.setState({ iscontestGoingOn: false });
        }
        else if (data.statusMessage == "submitted") {
            this.setState({ isSubmited: true });
        }
        else if (data.statusMessage == "Contest not started yet") {
            this.setState({ iscontestNotStarted: true, contestStartDate: new Date(data.data.startdate).toLocaleString() });
        }
    }


    handleContestClick = async (e, item, idx) => {


        const response = await fetch('v1/api/contestanswer', {
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "ContestId": this.state.contest.id,
                "OptionId": item.songId,
                "UserId": this.state.userId
            })
        });
        const data = await response.json();
        if (data.status) {
            item.isCorrect = data.data;
            this.state.items[idx] = item;
            var data2 = this.state.items;
            this.setState({ items: data2 })
        } else {
            //

        }

    };

    handleContestSubmitClick = async () => {


        const response = await fetch('v1/api/contestsubmit', {
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "ContestId": this.state.contest.id,
                "UserId": this.state.userId
            })
        });
        const data = await response.json();
        if (data.status) {
            this.setState({ isSubmited: true, contest:null });
        } else {
            alert(data.data);
        }

    };

    handleSwitchLiveClick = async () => {

        let vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
        let vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);

        if (!this.state.showVideo) { this.state.showVideo = true; } else { this.state.showVideo = false; }

        if (this.state.showVideo) {

            $("#tvscreen_panel").html("");
            $("#tvscreen_panel").html("<iframe src=\"https://www.9xtashan.in/livetv.php\" frameBorder=\"0\" height=\"750px\" width=\"100%\" />");
            $("#switch_live").val("Close Live Stream");

        } else {
            $("#switch_live").val("Switch to Live Stream");
            $("#tvscreen_panel").html("<img src=\"images/tv-screen.png\" alt=\"\" />");
        }
    }

   

    renderContest(data) {
        return data?.map((item, idx) => {
            if (item.thumbnail != "") {
                return (
                    <>
                        <li>


                            <input type="checkbox" id={item.isCorrect == null ? item.songId : idx} checked = {item.isCorrect == null? false: true } onClick={(event) => this.handleContestClick(event, item, idx)} />

                            {item.isCorrect == true ?
                                <label for={item.songId}>
                                    <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M13 50.986L37.334 75 88 25" stroke-width="10" stroke="#4ac400" fill="none" fill-rule="evenodd" stroke-dasharray="150" stroke-dashoffset="150" />
                                    </svg>
                                </label>
                                : (item.isCorrect == false ? < label for={item.songId}>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130 130">
                                        <path fill="none" stroke="#ff1c1c" stroke-linecap="round" stroke-linejoin="round" stroke-width="10" d="M34 34l62 62m0-62L34 96" stroke-dasharray="200" stroke-dashoffset="200" />
                                    </svg>
                                </label>
                                    : <></>)
                            }
                            <img src={idx % 2 == 0 ? item.thumbnail.replace('/images/contest_card', '/tambola/images/contest_card/Circle_Pink') : item.thumbnail.replace('/images/contest_card', '/tambola/images/contest_card/Circle_Green')} alt="" />
                        </li>
                    </>
                );
            }
            else {
                return (
                    <>
                        <li>
                        </li>
                    </>
                );
            }

        })
    }

    renderOptionAge(optionList) {
        return optionList?.map((optionItem, idx) => { // here

            return (
                <>
                    <option value={optionItem}>{optionItem}</option>
                </>
            );
        });
    }

    render() {


        if (this.state.data == null) {
            return (
                <>
                    <section id="register">
                        <div class="container">
                            <div class="row">
                                <div class="col-sm-12">



                                    <form onSubmit={(event) => this.handleSubmit(event)} id="register_form">
                                        <div class="register">
                                            <h2>Register</h2>
                                            <div class="row">
                                                <div class="col-6 mb-3">
                                                    <input type="text" class="form-control" required placeholder="Enter First Name" name="fname" value={this.state.fname} onChange={this.handleInputChange} />
                                                </div>
                                                <div class="col-6 mb-3">
                                                    <input type="text" class="form-control" required placeholder="Enter Last Name" name="lname" value={this.state.lname} onChange={this.handleInputChange} />
                                                </div>
                                                <div class="col-12 col-sm-12 col-md-6 mb-3">
                                                    <input type="text" class="form-control" required placeholder="Email" name="email" value={this.state.email} onChange={this.handleInputChange} />
                                                </div>
                                                <div class="col-12 col-sm-12 col-md-6 mb-3">
                                                    <input type="text" class="form-control" required placeholder="Contact No." name="phone" value={this.state.phone} onChange={this.handleInputChange} maxlength="10" />
                                                </div>
                                                <div class="col-6 mb-3">
                                                    <input type="text" class="form-control" required placeholder="City" name="city" value={this.state.city} onChange={this.handleInputChange} />
                                                </div>
                                                <div class="col-6 mb-3">
                                                    <input type="text" class="form-control" required placeholder="Pincode" name="country" value={this.state.country} onChange={this.handleInputChange} />
                                                </div>
                                                <div class="col-6 mb-3">
                                                    <select class="form-select" value={this.state.age} onChange={this.handleInputChange} name="age" >
                                                        <option value="" >Age</option>
                                                        {this.renderOptionAge(this.state.ageList)}


                                                    </select>
                                                </div>
                                                <div class="col-6 mb-3">
                                                    <select class="form-select" value={this.state.gender} onChange={this.handleInputChange} name="gender"  >
                                                        <option value="">Gender</option>
                                                        <option value="Male">Male</option>
                                                        <option value="Female">Female</option>
                                                    </select>
                                                </div>
                                                <div class="col-12 mb-3">
                                                    <div class="form-check">
                                                        <input class="form-check-input" type="checkbox" name="terms_ckbk" id="term" />
                                                        <label class="form-check-label" data-bs-toggle="modal" data-bs-target="#terms" >                                                            
                                                            Terms and Conditions
                                                        </label>
                                                    </div>

                                                    <div class="modal fade" id="terms" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1">
                                                        <div class="modal-dialog terms-dialog modal-dialog-centered">
                                                            <div class="modal-content">
                                                                <div class="modal-body">
                                                                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                                                                    <h1 class="modal-title">Terms and Conditions</h1>                                            

                                                                    <embed src="docs/spykar_terms_condition.pdf" type="application/pdf" width="100%" height="600px" class="desktop-view" />
                                                                    <a href="docs/spykar_terms_condition.pdf" target="_blank" class="mobile-view text-center" >Click here to read terms & conditions</a>
                                                                   
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                                <div class="col-12 text-center">
                                                    <input type="submit" class="btn btn-common" value="Enter Contest" />

                                                    {((this.state.loading == true) ? 'Submitting..' : '')}
                                                </div>
                                            </div>
                                            <img src="images/GIF-02.gif" class="element-bade" alt="" />

                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </section>
                </>);
        }

        if (this.state.questions != null && this.state.data != null && this.state.questions.data.length > 0 && this.state.questions.data.length != this.state.qusAnswered) {

            return (
                <>
                    <section id="quiz-t">
                        <div class="container">
                            <div class="row">
                                <div class="col-sm-12">

                                    <div id="quiz-container">
                                        <h6 id="question-counter">Question {this.state.index} of {this.state.questions.data.length}</h6>
                                        <div id="quiz-form" class="text-center">
                                            {this.renderQuestions(this.state.questions.data)}
                                        </div>
                                        <p id="feedback"></p>

                                    </div>
                                </div>


                            </div>
                        </div>
                    </section>
                </>);
        }

        if (this.state.contest != null) {

            //return (
            //    <>
            //        <Questions userId={this.state.userId} sponserId={this.props.sponserId}></Questions>
            //        <Contest userid={this.state.userId}></Contest>
            //    </>
            //);

            return (

                <>
                    <section id="tv_screen">
                        <div class="container">
                            <div class="row">
                                <div class="col-sm-12 position-relative text-center">
                                    <input id="switch_live" class="btn btn-common" type="button" value="Switch to Live Stream" onClick={(event) => this.handleSwitchLiveClick()} />
                                    <div id="tvscreen_panel">
                                        <img src="images/tv-screen.png" alt="" />
                                    </div>
                                </div>

                            </div>
                        </div>
                       
                        <img src="images/GIF-02.gif" class="element-bade2" alt="" />
                    </section>

                    <section id="contest">
                        <div class="container">
                            <div class="row">
                                <div class="col-sm-12 text-center">
                                    <img src="images/element-gift.png" width="50" alt="" />
                                    <h3>Game No #{this.state.contestId}</h3>
                                </div>
                                <div class="col-sm-12 position-relative text-center">
                                    <ul class="contest">
                                        {this.renderContest(this.state.items)}
                                    </ul>
                                    <img src="images/contest-wrapper.png" class="cover" alt="" />

                                </div>
                                <div class="col-sm-12 text-center"><button class="btn btn-common w-75" onClick={(event) => this.handleContestSubmitClick()} >Submit</button></div>
                            </div>
                        </div>
                        <img src="images/GIF-01.gif" class="element-bade" alt="" />

                    </section>
                </>);

        }

        if (!this.state.iscontestGoingOn) {
            return (

                <>
                    <section id="tv_screen">
                        <div class="container">
                            <div class="row">
                                <div class="col-sm-12 position-relative text-center">
                                    <input id="switch_live" class="btn btn-common" type="button" value="Switch to Live Stream" onClick={(event) => this.handleSwitchLiveClick()} />
                                    <div id="tvscreen_panel">
                                        <img src="images/tv-screen.png" alt="" />
                                    </div>
                                </div>

                            </div>
                        </div>
                        <img src="images/GIF-02.gif" class="element-bade2" alt="" />
                    </section>

                    <section id="contest">
                        <div class="container">
                            <div class="row">
                                <div class="col-sm-12 text-center">
                                    <img src="images/element-gift.png" width="50" alt="" />
                                    <h3>Contest</h3>
                                </div>
                                <div class="col-sm-12 position-relative text-center">
                                    <h2 class="text-white">Kheliyae kal subha 9 baje se</h2>

                                </div>
                               
                            </div>
                        </div>
                        <img src="images/GIF-01.gif" class="element-bade" alt="" />

                    </section>
                </>);
        }
        if (this.state.iscontestNotStarted) {
            return (

                <>
                    <section id="tv_screen">
                        <div class="container">
                            <div class="row">
                                <div class="col-sm-12 position-relative text-center">
                                    <input id="switch_live" class="btn btn-common" type="button" value="Switch to Live Stream" onClick={(event) => this.handleSwitchLiveClick()} />
                                    <div id="tvscreen_panel">
                                        <img src="images/tv-screen.png" alt="" />
                                    </div>
                                </div>

                            </div>
                        </div>
                        <img src="images/GIF-02.gif" class="element-bade2" alt="" />
                    </section>

                    <section id="contest">
                        <div class="container">
                            <div class="row">
                                <div class="col-sm-12 text-center">
                                    <img src="images/element-gift.png" width="50" alt="" />
                                    <h3>Contest</h3>
                                </div>
                                <div class="col-sm-12 position-relative text-center">
                                    <h2 class="text-white">Contest not started yet, will start on <b>{this.state.contestStartDate}</b>!</h2>

                                </div>

                            </div>
                        </div>
                        <img src="images/GIF-01.gif" class="element-bade" alt="" />

                    </section>
                </>);
        }


        if (this.state.isSubmited) {
            return (
                <>
                    <section id="congratulation">
                        <div class="container">
                            <div class="row">
                                <div class="col-sm-12 text-center">
                                    <div class="content-panel">
                                        <img src="images/congratulations.png" alt="" />                                       
                                        <a class="btn btn-common w-75" href="/tambola">Back to Home</a>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </section>
                </>
            );
        }
    }
}
